import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Guid } from '@core/utils/guid';
import { AvailableSchedule, ClassroomCourse, ClassroomCourseFilter } from '../../models';
import * as fromAction from '../classroom-course.action';
import * as fromSelector from '../classroom-course.selector';
import { ClassroomCourseState } from '../classroom-course.state';
import { Review } from '@shared/models/review';
import { Feedback } from '../../models/feedback';
import { Participant } from '../../models/participant';

@Injectable()
export class ClassroomCourseStoreService {
  constructor(private store: Store<ClassroomCourseState>) {}

  fetchAllClassroomCourses(filter: ClassroomCourseFilter): void {
    this.store.dispatch(fromAction.FetchClassroomCourses({ filter }));
  }

  fetchClassroomCourse(courseId: string): void {
    this.store.dispatch(fromAction.FetchClassroomCourse({ courseId }));
  }

  fetchAvailableSchedule(courseId: string): void {
    this.store.dispatch(fromAction.FetchClassroomSchedule({ courseId }));
  }

  fetchInstructorCourse(instructorId: string): void {
    this.store.dispatch(fromAction.FetchInstructorCourses({ instructorId }));
  }

  submitCourseReview(id: string, review: Review): void {
    this.store.dispatch( fromAction.SaveClassroomReview({ courseId: id, review: review }));
  }

  submitCourseFeedback(id: string, feedback: Feedback): void {
    this.store.dispatch( fromAction.SaveClassroomFeedback({ courseId: id, feedback }));
  }

  getAllClassroomCourse(): Observable<ClassroomCourse[]> {
    return this.store.pipe(select(fromSelector.getAllClassroomCourse));
  }

  getClassroomCourse(courseId: string): Observable<ClassroomCourse> {
    if (Guid.IsGuid(courseId)) {
      return this.store.select(fromSelector.getClassroomCourseById(courseId));
    } else {
      return this.store.select(fromSelector.getClassroomCourseBySlug(courseId));
    }
  }

  addSelectedClassroomCourse(selectedCourseId: string): void {
    this.store.dispatch(fromAction.AddSelectedCourse({ selectedCourseId }));
  }

  getSelectedClassroomCourse(): Observable<ClassroomCourse> {
    return this.store.pipe(select(fromSelector.getSelectedClassroomCourse));
  }

  getAvailableSchedule(): Observable<AvailableSchedule[]> {
    return this.store.pipe(select(fromSelector.getAvailableSchedule));
  }

  removeAvailableSchedule(): void {
    this.store.dispatch(fromAction.RemoveClassroomSchedule());
  }

  getInstructorCourse(): Observable<ClassroomCourse[]> {
    return this.store.pipe(select(fromSelector.getInstructorCourse));
  }

  removeSelectedClassroomCourse(): void {
    this.store.dispatch(fromAction.RemoveSelectedClassroomCourse());
  }

  checkParticipantIdentity(phone: string): void {
    this.store.dispatch(fromAction.CheckParticipantIdentity({ phone }));
  }

  getParticipantIdentity(): Observable<Participant> {
    return this.store.pipe(select(fromSelector.getParticipantIdentity));
  }

  removeParticipantIdentity(): void {
    this.store.dispatch(fromAction.RemoveParticipantIdentity());
  }

  decreaseScheduleCount(courseId: string, scheduleId: number, numOfBooking: number): void {
    this.store.dispatch(fromAction.DecreaseScheduleCount({ courseId, scheduleId, numOfBooking }));
  }

  addError(error: any): void {
    this.store.dispatch(fromAction.AddError(error));
  }
}
